import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { FormattedMessage } from 'react-intl';

import { useSendQuestionMutation } from '@/services/chatApi/chatApi';

import { ActionIconButton } from './Styles';
import { TActionIconProps } from './types';

const ActionIcon = ({ onClick, iconClass, tooltipText }: TActionIconProps) => {
  const [, { isLoading: isSendMessageLoading }] = useSendQuestionMutation();

  return (
  <OverlayTrigger
    placement="top"
    overlay={
      <Tooltip>
        <FormattedMessage id={tooltipText} />
      </Tooltip>
    }
  >
    <ActionIconButton className={iconClass} onClick={onClick} disabled={isSendMessageLoading} />
  </OverlayTrigger>
)
};

export default ActionIcon;
